export enum ECarrierIdentifiers {
  Athlete = 'Data Roaming ATHLETE Countries - ABO - ab 2020-10',
}
